import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { AuthLayoutComponent } from './components/auth-layout/auth-layout.component';
import { RegisterComponent } from './pages/register/register.component';
import { RegisterIncubatorComponent } from './pages/register-incubator/register-incubator.component';
import { CheckEmailComponent } from './pages/check-email/check-email.component';
import { EmailConfirmedComponent } from './pages/email-confirmed/email-confirmed.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { CreateNewPasswordComponent } from './pages/create-new-password/create-new-password.component';
import { VerifyEmailComponent } from './pages/verify-email/verify-email.component';

const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        data: { title: 'Login' },
      },
      {
        path: 'register',
        component: RegisterComponent,
        data: { title: 'Register' },
      },
      {
        path: 'register-incubator',
        component: RegisterIncubatorComponent,
        data: { title: 'Register Incubator' },
      },
      {
        path: 'check-email',
        component: CheckEmailComponent,
        data: { title: 'Check Email' },
      },
      {
        path: 'email-confirmed',
        component: EmailConfirmedComponent,
        data: { title: 'Email Confirmed' },
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        data: { title: 'Forgot Password' },
      },
      {
        path: 'new-password',
        component: CreateNewPasswordComponent,
        data: { title: 'New Password' },
      },
      {
        path: 'verify-email',
        component: VerifyEmailComponent,
        data: { title: 'Verify Email' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
